import {
    Box,
    Text,
    VStack,
    HStack,
    Flex,
    Badge,
} from '@chakra-ui/react';
import QuotingTag from '../QuotingTag';
import { OrderDrawerResponse } from '../../hooks/useGetOrderDrawer';

const formatEstReturnTime = (time: Date | string | null | undefined) => {
    if (!time) {
        return null;
    }
    return `Est. Return ${new Date(time).toLocaleString('en-US', {
        month: 'numeric',
        day: 'numeric',
        year: '2-digit',
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
    }).toLowerCase()}`;
};

interface QuotingTabPanelProps {
    data: NonNullable<OrderDrawerResponse['quotes']>;
}

const QuotingTabPanel = ({ data }: QuotingTabPanelProps) => {
    return (
        <Box>
            <Text fontSize="xs" fontWeight="bold" color="gray.500" mb={4} letterSpacing="wide" textTransform="uppercase">
                QUOTE SUBMISSIONS
            </Text>
            <VStack align="stretch" spacing={4}>
                {data.quotes.map((quote, index, arr) => (
                    <Box key={quote._id} p={4} borderWidth="1px" borderRadius="lg" bg="white" borderColor="gray.200" boxShadow="none">
                        <VStack align="stretch" spacing={3}>
                            {/* Header Row */}
                            <Flex justify="space-between" align="center">
                                <HStack spacing={3}>
                                    <Text fontSize="md" fontWeight="bold" >
                                        Quote {arr.length - index}
                                    </Text>
                                    <Box h="14px" w="1px" bg="gray.300" />
                                    <Text fontSize="md" color="gray.600">
                                        {new Date(quote.timestamp).toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' })} • {new Date(quote.timestamp).toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit' })}
                                    </Text>

                                    {/* Tags */}
                                    <HStack spacing={2}>
                                        <QuotingTag
                                            tag={quote.preOrder ? 'pre-order' : 'on-site'}
                                            text={quote.preOrder ? 'PRE-ORDER' : 'ON-SITE'}
                                        />
                                        {quote.autoOrder && (
                                            <QuotingTag
                                                tag='auto-order'
                                                text='AUTO ORDER'
                                            />
                                        )}
                                    </HStack>
                                </HStack>
                                <Badge
                                    px={3}
                                    py={1}
                                    borderRadius="full"
                                    variant="solid"
                                    bg={quote.status === 'open' ? "green.50" : "red.50"}
                                    color={quote.status === 'open' ? "green.800" : "red.800"}
                                    fontSize="sm"
                                    textTransform="capitalize"
                                    borderWidth="1px"
                                    borderColor={quote.status === 'open' ? "green.200" : "red.200"}
                                >
                                    {quote.status}
                                </Badge>
                            </Flex>

                            <Flex justify="space-between" align="flex-start">
                                <VStack align="flex-start" spacing={1}>
                                    <Text fontSize="sm" color="gray.600">
                                        Submitted by <Text as="span" fontWeight="bold" color="gray.900">{quote.submittedBy}</Text>
                                    </Text>
                                    {quote.estReturnTime && (
                                        <Text fontSize="sm" color="gray.600">
                                            {formatEstReturnTime(quote.estReturnTime)}
                                        </Text>
                                    )}
                                </VStack>

                                {/* Stats */}
                                <HStack bg="gray.50" px={4} py={2} borderRadius="md" textAlign="right" >
                                    <Text fontSize="xl" fontWeight="bold" color="gray.900" lineHeight="1">
                                        {quote.totalParts}
                                    </Text>
                                    <Text fontSize="xs" fontWeight="bold" color="gray.500" mb={0}>
                                        PARTS
                                    </Text>
                                </HStack>
                            </Flex>
                        </VStack>
                    </Box>
                ))}
            </VStack>
        </Box>
    );
};

export default QuotingTabPanel;

